export const SITE_NAME = 'Sista Kyerewaa';
export const SITE_URL = 'https://www.sistakyerewaa.com';
export const BRAND_TAGLINE = 'Sista Kyerewaa - Integration, Culture & Life in Germany for African Families.';
export const BLOG_FALLBACK_COVER = `${SITE_URL}/default-blog-cover.svg`;
export const DEFAULT_OG_IMAGE = BLOG_FALLBACK_COVER;

export const buildTitle = (pageTitle) => `${pageTitle} | ${SITE_NAME}`;

export const stripHtml = (value = '') => value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

// Meta descriptions: cut at a word boundary instead of mid-word.
export const clipDescription = (text = '', max = 160) => {
  const t = String(text).trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1).replace(/\s+\S*$/, '')}…`;
};
